import type { ShopNotificationSummary } from "@/modules/notifications/domain/repo/shop-notification-summary";
import type { ShopNotificationRow } from "@/modules/notifications/domain/repo/list-shop-notifications";
import type { OffsetPageDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

function shopNotificationsBaseUrl(shopId: string) {
  return `${config.apiUrl}/shops/${shopId}/notifications`;
}

export type { ShopNotificationSummary, ShopNotificationRow };

export const shopNotificationsApi = {
  async getSummary(shopId: string): Promise<ShopNotificationSummary> {
    return fetcher.get<ShopNotificationSummary>(
      `${shopNotificationsBaseUrl(shopId)}/summary`,
    );
  },

  async getUnreadCount(shopId: string): Promise<{ count: number }> {
    return fetcher.get<{ count: number }>(
      `${shopNotificationsBaseUrl(shopId)}/unread-count`,
    );
  },

  async list(
    shopId: string,
    params?: {
      limit?: number;
      offset?: number;
      unreadOnly?: boolean;
      type?: string;
    },
  ): Promise<OffsetPageDTO<ShopNotificationRow>> {
    const search = new URLSearchParams();
    if (params?.limit != null) search.set("limit", String(params.limit));
    if (params?.offset != null) search.set("offset", String(params.offset));
    if (params?.unreadOnly) search.set("unreadOnly", "true");
    if (params?.type) search.set("type", params.type);
    const qs = search.toString();
    return fetcher.get<OffsetPageDTO<ShopNotificationRow>>(
      `${shopNotificationsBaseUrl(shopId)}${qs ? `?${qs}` : ""}`,
    );
  },

  async markRead(shopId: string, id: string): Promise<{ ok: true }> {
    return fetcher.post<{ ok: true }>(
      `${shopNotificationsBaseUrl(shopId)}/${id}/read`,
    );
  },

  async markAllRead(shopId: string): Promise<{ marked: number }> {
    return fetcher.post<{ marked: number }>(
      `${shopNotificationsBaseUrl(shopId)}/read-all`,
    );
  },
};
